import { useDispatch, useSelector } from "react-redux";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { Form, Input, Spin } from "antd";
import { loginIntial } from "../../features/auth/authSlice";
import { useEffect, useRef } from "react";
import Header from "./Header";
import { clearObj } from "../../features/obj/objSlice";
import toast from "react-hot-toast";
import RightSide from "./RightSide";
import svg77 from "../../assets/svg/svg77.svg";
import svg8 from "../../assets/svg/svg8.svg";

export default function LoginPassword() {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { authLoading, accountInfo } = useSelector((state) => state.auth);
  const { activeObj } = useSelector((state) => state.obj);
  const { subdomain } = useSelector((state) => state.global);
  const formRef = useRef(null);
  const onFinish = async (data) => {
    if(!accountInfo?.userEmail || !activeObj?.orgCode ){
      toast.error("Please select organization in the previous step")
      return;
    }
    const res = await dispatch(
      loginIntial({
        userEmail:accountInfo?.userEmail,
        usrOrgCode: activeObj?.orgCode,
        ...data,
      })
    );
    if (res?.payload?.success) {
      toast.success(res?.payload?.messages?.message);
      await form.resetFields();
      await navigate("/login-otp");
    } else {
      toast.error(res?.payload?.messages?.message ?? "Invalid Credentials");
    }
  };

  const handleRegister = async () => {
    await dispatch(clearObj());
    await navigate("/registration");
  };

  useEffect(() => {
    if (accountInfo?.userEmail) { 
      form.setFieldsValue({
        userEmail: accountInfo?.userEmail,
      });
    }
  }, [accountInfo?.userEmail, form]);
 
  return (
    <div className="overflow-y-auto min-h-screen h-screen w-full">
      <div className="flex w-full  min-h-screen bg-white ">
        <div className="flex flex-col w-full ">
          <Header />
          <div className="w-full h-full flex flex-col justify-center items-center">
            <div className="w-full max-w-[32.25rem] flex flex-col lg:px-0 px-3">
              <span
                className={`heading_1 ${
                  subdomain === "ndovupay" || subdomain === "localhost"
                    ? "!text-[#DB2A12]"
                    : "text-inherit"
                }`}
              >
                Input Credentials
              </span>
              <span className="paragraph_1 mt-[1.13rem]">
                Welcome. Please fill in your password below.
              </span>

              <Form
                layout="vertical"
                ref={formRef}
                name="control-ref"
                onFinish={onFinish}
                style={{
                  maxWidth: "100%",
                  marginTop: "2.06rem",
                  width: "100%",
                }}
                form={form}
              >
                <Form.Item
                  label="Email"
                  rules={[
                    {
                      required: true,
                      message: "Email is required to login",
                    },
                    {
                      type: "email",
                      message: "Please enter a valid email address",
                    },
                  ]}
                >
                  <Input
                    value={accountInfo?.userEmail}
                    readOnly
                    prefix={<img src={svg77} alt="svg77" />}
                    type="email"
                    className="input"
                  />
                  <div className="mt-[.75rem] font-dmSans rounded-[.25rem] bg-[#FFB600]/10 py-[.25rem] px-[.5rem] flex items-center gap-[.5rem] text-ndovuRed text-[.875rem] font-[300] leading-normal">
                    {activeObj?.orgName}
                    <span>•</span>
                    <span>{activeObj?.orgCode}</span>
                  </div>
                </Form.Item>

                <Form.Item
                  name="password"
                  label="Password"
                  rules={[
                    {
                      required: true,
                      message: "Please enter your password",
                    },
                  ]}
                >
                  <Input.Password
                    prefix={<img src={svg8} alt="svg8" />}
                    className="input"
                  />
                </Form.Item>

                <div className="flex justify-end mt-[.5rem]">
                  <Link to="/forgot-password" className="label_2 underline">
                    Forgot Password?
                  </Link>
                </div>

                <div className="w-full flex flex-col">
                  <div className="flex  mt-[1.63rem]">
                    <button
                      className="cstm-btn-2 !bg-[#000000]"
                      type="submit"
                      disabled={authLoading ? true : false}
                    >
                      {authLoading ? <Spin /> : "Sign In"}
                    </button>
                  </div>

                  <div className="w-full justify-center flex mt-[1.19rem]">
                    <span className="label_2 !text-[#0A0A0A]">
                      Don’t have an account?{" "}
                    </span>
                    <button
                      type="button"
                      className=" label_2 !text-[#DB2A12] ml-[.1rem]"
                      onClick={handleRegister}
                    >
                      Register
                    </button>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>

        <RightSide />
      </div>
    </div>
  );
}
